import React, { useEffect, useState } from "react";
import styles from "./VoxbayWidget.module.css"; // Ensure this CSS module is properly set up
import CloseIcon from "@mui/icons-material/Close";
import call_ozonetel from "../../../../assets/images/call_ozonetel.svg";
import {
  leadCallDispositionForm,
  resetCallDispositionFormStatuses,
  resetCallDispositionFormStatusesForVoxbay,
  setHideOzonetelWidget,
  setShowOzonetelWidget,
} from "../service/IntegrationsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import dial from "../../../../assets/images/Choices.svg";
import { Box, InputLabel } from "@mui/material";
import CountryCodePhoneInput from "../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import { isValidPhoneNumber } from "libphonenumber-js";
import NewFormTextInput from "../../../../components/FormTextInput/NewFormTextInput";
import { ErrorType } from "../../../../components/FormTextInput/types";
import DialerBack from "../../../../assets/images/DialerBack.svg";
import {
  resetVoxbayAddLeadForUnknownSuccess,
  resetVoxbayClickToCallSuccess,
  setHideVoxbayWidget,
  setShowVoxbayNumber,
  setShowVoxbayWidget,
  voxbayClickToCall,
} from "../service/voxbaySlice";
import { useAuthUser } from "react-auth-kit";
import { useParams, useSearchParams } from "react-router-dom";
import AddLeadCardForUnknownLeads from "../../../../components/LeadPopup/subComponents/AddLeadCardForUnknownLeads";
// import Voxbay from "../../../../assets/images/Voxbay Logo Final.svg";
import Voxbay from "../../../../assets/images/Vox.png";
import LeadCallDispositionForm from "../../../../components/LeadPopup/subComponents/LeadCallDispositionForm";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import ViewLeadCardPopUp from "../../Nurture/components/ViewLeadCard";

interface VoxbayWidgetProps {
  url: string; // URL to be loaded in the iframe
  buttonText: string; // Text for the button to open the popup
}

const VoxbayWidget: React.FC<VoxbayWidgetProps> = ({ url, buttonText }) => {
  // const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [agentLoginDetails, setAgentLoginDetails] = useState(null);
  const [phone, setPhone] = useState("");
  const [contactCountryCode, setContactCountryCode] = useState("91");
  const [validStateContact, setValidStateContact] =
    React.useState<boolean>(true);

  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const [validPhoneNo, setValidStatePhoneNo] = React.useState<boolean>(true);
  const [showDialer, setShowDialer] = useState(false);

  const auth = useAuthUser();
  const authUser = auth();
  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;
  const instituteFromUser = authUser?.institute?.[0];

  const [searchParams] = useSearchParams();
  const leadId = searchParams.get("leadId");

  const dispatch = useDispatch();

  const handleClose = () => {
    // dispatch(setHideOzonetelWidget());
    dispatch(setHideVoxbayWidget());
    dispatch(setShowVoxbayNumber(""));
  };

  const handleOpen = () => {
    // dispatch(setShowOzonetelWidget());
    dispatch(setShowVoxbayWidget());
    dispatch(setShowVoxbayNumber(""));
  };

  const { ozonetelWidgetShow } = useSelector(
    (state: any) => state.appIntegrations
  );

  const { voxbayWidgetShow, voxbayWidgetNumber, voxbayClickToCallSuccess } =
    useSelector((state: any) => state.voxbay);

  const handleChange = (event: any) => {
    setShowErrMsz(true);
    if (errorType === "server") {
      setValidStatePhoneNo(true);
    }
    setErrorType("client");
    const onlyNumbers = event.target.value.replace(/[^0-9]/g, "");

    setPhone(onlyNumbers);
  };

  const setValidateStatusPhone = React.useCallback((val: boolean) => {
    setValidStatePhoneNo(val);
  }, []);

  const { voxbayDispositionFlag } = useSelector(
    (state: any) => state?.websocketNotifications
  );

  const DIAL_KEYS = [
    { key: "1", sub: "" },
    { key: "2", sub: "ABC" },
    { key: "3", sub: "DEF" },
    { key: "4", sub: "GHI" },
    { key: "5", sub: "JKL" },
    { key: "6", sub: "MNO" },
    { key: "7", sub: "PQRS" },
    { key: "8", sub: "TUV" },
    { key: "9", sub: "WXYZ" },
    { key: "*", sub: "" },
    { key: "0", sub: "+" },
    { key: "#", sub: "" },
  ];

  const handlePress = (value: any) => {
    setPhone((prev) => {
      if (prev.length >= 10) return prev;
      return prev + value;
    });
  };

  const handleDelete = () => {
    setPhone((prev) => prev.slice(0, -1));
  };

  // useEffect(() => {
  //   if (voxbayWidgetNumber !== "") {
  //     setPhone(voxbayWidgetNumber);
  //   } else {
  //     setPhone("");
  //   }
  // }, [voxbayWidgetNumber]);

  useEffect(() => {
    if (voxbayClickToCallSuccess === true) {
      setPhone("");
      dispatch(setHideVoxbayWidget());
      dispatch(resetVoxbayClickToCallSuccess());
    }
  }, [voxbayClickToCallSuccess]);

  const handleClickToCall = () => {
    const data = {
      destination: phone,
      instituteId: instituteDetails?.id,
      assignedToName:
        instituteFromUser?.firstName + " " + instituteFromUser?.lastName,
      assignedToId: instituteFromUser?.id,
    };
    // if (leadId) {
    //   dispatch<any>(voxbayClickToCall({ ...data, enquiryId: leadId }));
    // } else {
    dispatch<any>(voxbayClickToCall(data));
    // }
  };

  const employees = useSelector((state: any) => state.staff.staffList);
  const ozonetelEmployees = employees?.filter(
    (item: any) => item.voxbayConfig && item?.id === instituteFromUser?.id
  );

  const {
    editNoteSuccess,
    deleteNoteSuccess,
    deleteTaskSuccess,
    editTaskSuccess,
    sendPaymentLinkSuccess,
    downloadPaymentReceiptError,
    downloadPaymentReceiptSuccess,
    leadEmiDetailsError,
    leadEmiDetailsSuccess,
    editDemoSuccess,
    createDemoSuccess,
    composeEmailSuccess,
    leadLostUpdateSuccess,
    createPaymentSuccess,
    leadConvertionError,
    leadStatusUpdateError,
    leadStatusUpdateSuccess,
    leadUpdateSuccess,
    leadCreateSuccess,
    deleteDemoBookedSuccess,
    recordPaymentUpdateSuccess,
    recordPaymentUpdateError,

    getEmiDataloading,
    leadEmiDetailsLoading,
    leadBoardLoading,
    leadListLoading,
    createDemoLoading,
    deleteDemoBookedLoading,
    noteListLoading,
    leadActivityLoading,
    inboxLoading,
    paymentListLoading,
    leadTasksloading,
    leadListByContact,
    leadBoard,
    autoDebitSuccess,
    leadDiscountSuccess,
    pauseSuccess,
    randomPaymentSuccess,
    deleteAdditionalPaySuccess,
    sessionPayRecordSuccess,
    deleteTransactionSuccess,
  } = useSelector((state: any) => state.nurture);
  const swimlaneData = leadBoard?.swimlaneData;
  const leadStages =
    swimlaneData &&
    [...swimlaneData]?.sort((a: any, b: any) => {
      return a?.orderIndex - b?.orderIndex;
    });
  const taskTypes = leadBoard?.taskType;

  const CallDispositionForm = (data: any) => {
    dispatch<any>(leadCallDispositionForm(data));
  };

  const { callDispositionForVoxbaySuccess } = useSelector(
    (state: any) => state.appIntegrations
  );

  React.useEffect(() => {
    if (callDispositionForVoxbaySuccess === true) {
      dispatch(
        setToastNotification({
          message: "Disposition added successfully",
          type: "success",
          snackOpen: true,
        })
      );
      dispatch(resetCallDispositionFormStatusesForVoxbay());
    }
  }, [callDispositionForVoxbaySuccess]);

  const { voxbayAddLeadForUnknownData } = useSelector(
    (state: any) => state.voxbay
  );
  const [open, setOpen] = useState(false);

  const handleViewLeadCard = () => {
    if (voxbayAddLeadForUnknownData?.enquiryId) {
      const instituteFromLocal = authUser?.institute[0]?.instituteDetails;
      let queryParams = `/app/Nurture?leadModal=true&leadInstituteId=${instituteFromLocal?.id}&leadId=${voxbayAddLeadForUnknownData.enquiryId}`;

      if (voxbayAddLeadForUnknownData.studentContact) {
        queryParams += `&leadPhone=${voxbayAddLeadForUnknownData.studentContact}`;
      }

      if (voxbayAddLeadForUnknownData.studentEmail) {
        queryParams += `&leadEmail=${voxbayAddLeadForUnknownData.studentEmail}`;
      }
      window.open(queryParams, "_blank");
      dispatch(resetVoxbayAddLeadForUnknownSuccess());
      setOpen(false);
    }
  };

  useEffect(() => {
    if (voxbayAddLeadForUnknownData?.enquiryId) {
      setOpen(true);
    }
  }, [voxbayAddLeadForUnknownData]);

  return (
    <>
      <div className={styles.ozonetelWidgetContainer}>
        <div style={{ position: "relative", zIndex: 999999 }}>
          <button
            className={styles.popupButton}
            // onClick={() => setIsPopupOpen(!isPopupOpen)}
            onClick={handleOpen}
          >
            <img src={Voxbay} alt="" className={styles.popupIcon} />
          </button>
        </div>

        {/* Adjusting the style to hide/show the iframe instead of unmounting it */}
        <div
          className={styles.popup}
          style={{
            display: voxbayWidgetShow ? "block" : "none",
            top: showDialer ? "62%" : "80%",
          }} // Control visibility with inline style
        >
          <div className={styles.voxbayContainer}>
            <div className={styles.voxbayHeader}>
              <div>Voxbay</div>
              <div
                className={styles.closeButton}
                // onClick={() => setIsPopupOpen(false)}
                onClick={handleClose}
              >
                <CloseIcon />
              </div>
            </div>
            <div className={styles.voxbayAgentContainer}>
              <div
                style={{ color: "rgba(126, 126, 126, 1)", fontSize: "15px" }}
              >
                Agent Name
              </div>
              <div
                style={{
                  color: "rgba(0, 0, 0, 1)",
                  fontSize: "18px",
                  textTransform: "capitalize",
                }}
              >
                {ozonetelEmployees[0]?.firstName}{" "}
                {ozonetelEmployees[0]?.lastName}
              </div>
            </div>
            <div className={styles.phoneNumberContainer}>
              <div>
                <NewFormTextInput
                  addStartAdornment
                  validate={true}
                  setValidStatus={setValidateStatusPhone}
                  label="Phone Number"
                  type="text"
                  error={!setValidStatePhoneNo}
                  value={phone}
                  onChange={handleChange}
                  showErrorMessage={showErrMsz}
                  errorType={errorType}
                  autoComplete="true"
                  require={true}
                  inputProps={{ maxLength: 10 }}
                />
              </div>
              <div
                style={{ marginTop: "15px", cursor: "pointer" }}
                onClick={() => {
                  setShowDialer(!showDialer);
                }}
              >
                <img src={dial} alt="" />
              </div>
            </div>
            {showDialer && (
              <div className={styles.dialerGrid}>
                {DIAL_KEYS.map((item) => (
                  <button
                    key={item.key}
                    className={styles.dialBtn}
                    onClick={() => handlePress(item.key)}
                  >
                    <div className={styles.digit}>{item.key}</div>
                    {item.sub && <div className={styles.sub}>{item.sub}</div>}
                  </button>
                ))}
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                className={styles.dialButton}
                style={{
                  borderRadius: phone?.length > 0 ? "50%" : "0%",
                  width: phone?.length === 0 ? "100%" : "",
                  cursor: "pointer",
                }}
                onClick={handleClickToCall}
              >
                Dial
              </div>
              {phone.length > 0 && (
                <div
                  onClick={handleDelete}
                  style={{ marginTop: "10px", cursor: "pointer" }}
                >
                  <img src={DialerBack} alt="" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {voxbayDispositionFlag === "CREATE_LEAD" && (
        <AddLeadCardForUnknownLeads />
      )}
      <LeadCallDispositionForm
        employees={employees}
        taskTypes={taskTypes}
        CallDispositionForm={CallDispositionForm}
      />
      <ViewLeadCardPopUp
        open={open}
        onClose={() => {
          dispatch(resetVoxbayAddLeadForUnknownSuccess());
          setOpen(false);
        }}
        yesBtnClick={handleViewLeadCard}
        title={`${voxbayAddLeadForUnknownData?.studentName} is successfully created as a lead`}
      />
    </>
  );
};

export default VoxbayWidget;
